import React from 'react';
import './style.scss';
import useUserData from '../../../contexts/userData';
import SVGLogout from '../../../assets/images/icons/logout';
import Link from '../../controls/link';
import clsx from 'clsx';

interface Props {
  inverted: boolean;
  closeMenu: () => void;
  className?: string;
}

const HeaderProfileBlock = ({ inverted, closeMenu, className }: Props) => {
  const { userName, logout } = useUserData();

  return (
    <div className={clsx('profile-block', inverted && 'inverted', className)}>
      <Link to='/' color={inverted ? 'default' : 'white'} onClick={closeMenu}>
        {userName}
      </Link>
      <SVGLogout
        className='profile-block-logout-icon'
        onClick={() => {
          logout();
          closeMenu();
        }}
        color={inverted ? '#000' : '#FFF'}
      />
    </div>
  );
};

export default HeaderProfileBlock;
